export enum EApi {
    REQUEST_SIGNUP_OTP = 'REQUEST_SIGNUP_OTP',
    AUTHENTICATE_USER = 'AUTHENTICATE_USER',
    FETCH_PRE_SIGN_UP_APP_CONFIG = 'FETCH_PRE_SIGN_UP_APP_CONFIG',
    GET_USER_DETAILS = 'GET_USER_DETAILS',
    GET_TOURNAMENTS_LIST = "GET_TOURNAMENTS_LIST",
    GET_PWA_HOME_SCREEN = "GET_PWA_HOME_SCREEN",
    GET_TOURNAMENT_DETAILS = "GET_TOURNAMENT_DETAILS",
    GET_LEADERBOARD_DETAILS = "GET_LEADERBOARD_DETAILS",
    REGISTER_TOURNAMENT = "REGISTER_TOURNAMENTS",
    GET_GAME_CONFIG = "GET_GAME_CONFIG",
    GET_TOURNAMENTS_HISTORY = "GET_TOURNAMENTS_HISTORY",
    SET_USER_LOCATION = "SET_USER_LOCATION",
    GET_PWA_POST_GAME_WD_DATA_EVENT = "GET_PWA_POST_GAME_WD_DATA_EVENT",
    GET_PLAN_STATE_V3 = "GET_PLAN_STATE_V3",
    INITIATE_SUBSCRIPTION_CHECKOUT = "INITIATE_SUBSCRIPTION_CHECKOUT",
    CREATE_CHECKOUT_ORDER = "CREATE_CHECKOUT_ORDER",
    PHONEPE_CHECKOUT_PAY = "PHONEPE_CHECKOUT_PAY",
    SUBSCRIPTION_POLLING = "SUBSCRIPTION_POLLING",
    GET_ORDER_STATUS = "GET_ORDER_STATUS",
  }
  
  export interface RootApiResponseWithData<T> {
    en: EApi;
    response: {
      // bankDetails: any;
      success: boolean;
      error?: string;
      errorType?: string;
      data?: T;
      userDetail?: T;
      widgets?: T;
      entities?: any;
      tournament?: any;
      externalMessage?: string;
      noResultText?: string;
    };
  }
  
  export interface RootApiResponseExtends<T> {
    en: EApi;
    response: {
      success: boolean;
      error?: string;
    } & Partial<T>;
  }
  
  export interface IBaseUrl {
    url: string;
    en: EApi;
  }